import { SharedModule } from './../shared/shared.module';
import { NgModule } from '@angular/core';

import { EmployeeRoutingModule } from './employee-routing.module';
import { EmployeeComponent } from './employee.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { ProfileFormComponent } from './components/profile-form/profile-form.component';
import { ProfileContactFormComponent } from './components/profile-contact-form/profile-contact-form.component';
import { OtherDetailsComponent } from './components/other-details/other-details.component';
import { DiseaseInfoComponent } from './components/disease-info-form/disease-info-form.component';
import { DisabledInfoFormComponent } from './components/disabled-info-form/disabled-info-form.component';
import { SingleWomenInfoComponent } from './components/single-women-info-form/single-women-form.component';
import { SpouseInInfoComponent } from './components/spouse-in-info-form/spouse-in-info-form.component';
import { SpouseOutInfoComponent } from './components/spouse-out-info-form/spouse-out-info-form.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { PresentPlaceFormComponent } from './components/present-place-form/present-place-form.component';
import { ServiceBookFormComponent } from './components/service-book/service-book-form/service-book-form.component';
import { ServiceBookListComponent } from './components/service-book/service-book-list/service-book-list.component';
import { TransferRequestComponent } from './components/transfer-request-form/transfer-request-form.component';
import { PreferenceComponent } from './components/preference/preference.component';
import { VacantPostComponent } from './components/vacant-post/vacant-post.component';
import { TransferRequestViewComponent } from './components/transfer-request-view/transfer-request-view.component';
import { ProfileThumbFormComponent } from './components/profile-thumb-form/profile-thumb-form.component';
import { TransferRequestUnlockComponent } from './components/transfer-request-unlock/transfer-request-unlock.component';
import { EmployeeMeritComponent } from './components/employee-merit/employee-merit.component';
import { GrivanceComponent } from './components/grivance/grivance.component';
import { AddGivanceComponent } from './components/grivance/add-givance/add-givance.component';
import { ViewGivanceComponent } from './components/grivance/view-givance/view-givance.component';

@NgModule({
  declarations: [ 
    EmployeeComponent,
    DashboardComponent,
    BreadcrumbComponent,
    ProfileFormComponent,
    ProfileThumbFormComponent,
    ProfileContactFormComponent,
    DiseaseInfoComponent,
    DisabledInfoFormComponent,
    SingleWomenInfoComponent,
    SpouseInInfoComponent,
    SpouseOutInfoComponent,
    NavbarComponent,
    OtherDetailsComponent,
    PresentPlaceFormComponent,
    ServiceBookFormComponent,
    ServiceBookListComponent,
    TransferRequestComponent,
    PreferenceComponent,
    VacantPostComponent,
    TransferRequestViewComponent,
    TransferRequestUnlockComponent,
    EmployeeMeritComponent,
    GrivanceComponent,
    AddGivanceComponent,
    ViewGivanceComponent
  ],
  imports: [
    SharedModule,
    EmployeeRoutingModule
  ]
})
export class EmployeeModule { }
